import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';

/**
 * Standard Sortable Table Header Component
 *
 * @param {Object} props
 * @param {string} props.columnId - Unique ID for the column
 * @param {string} props.label - Label to display
 * @param {string} props.sortBy - Current sort field
 * @param {string} props.sortOrder - Current sort order ('asc' or 'desc')
 * @param {Function} props.onSort - Callback for sort change
 * @param {string} props.className - Additional CSS classes
 */
const SortableHeader = ({
  columnId,
  label,
  sortBy,
  sortOrder,
  onSort,
  className = '',
}) => {
  const isSorted = sortBy === columnId;

  return (
    <th
      scope="col"
      className={`px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-widest bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors ${className}`}
      onClick={() => onSort(columnId)}
    >
      <div className="flex items-center gap-1">
        <span>{label}</span>
        <div className="flex flex-col">
          {isSorted ? (
            sortOrder === 'asc' ? (
              <ChevronUp className="h-3 w-3 text-primary-600" />
            ) : (
              <ChevronDown className="h-3 w-3 text-primary-600" />
            )
          ) : (
            <ChevronsUpDown className="h-3 w-3 text-gray-300 group-hover:text-gray-400" />
          )}
        </div>
      </div>
    </th>
  );
};

export default SortableHeader;
